import { Link, useParams } from '@tanstack/react-router';
import { Button, Card } from '@yhelp/ui';
import { DashboardLayout } from '@/templates/DashboardLayout';
import { getKbArticle } from '@/lib/kb-articles';

export function KbArticlePage() {
  const { articleId } = useParams({ from: '/authenticated/kb/$articleId' });
  const article = getKbArticle(articleId);

  if (!article) {
    return (
      <DashboardLayout>
        <Card className="p-8 text-center">
          <p className="font-bold text-yhelp-black dark:text-white">Artigo não encontrado</p>
          <Link to="/kb" className="mt-4 inline-block">
            <Button variant="secondary">Voltar à base</Button>
          </Link>
        </Card>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout pageTitle={article.title} pageDescription={article.category}>
      <Link to="/kb" className="mb-4 inline-block text-sm text-muted hover:underline">
        ← Voltar à base de conhecimento
      </Link>
      <Card className="p-8">
        <p className="text-xs font-medium uppercase tracking-wide text-muted">{article.category}</p>
        <h2 className="mt-2 text-2xl font-extrabold text-yhelp-black dark:text-white">
          {article.title}
        </h2>
        <p className="mt-2 text-muted">{article.summary}</p>
        <div className="mt-8 space-y-4 text-neutral-700 dark:text-neutral-300">
          {article.body.map((paragraph) => (
            <p key={paragraph} className="leading-relaxed">
              {paragraph.split(/\*\*(.*?)\*\*/g).map((part, i) =>
                i % 2 === 1 ? (
                  <strong key={i} className="font-semibold text-yhelp-black dark:text-white">
                    {part}
                  </strong>
                ) : (
                  part
                ),
              )}
            </p>
          ))}
        </div>
      </Card>
    </DashboardLayout>
  );
}
